module.exports = __webpack_public_path__ + "e4b7cf20ec1e4099c415f8e8c84aee82.pdf";